import { hasVoted, useVotes, voterKey } from '@/hooks/useVotes';
import { useAuth } from '@/hooks/useAuth';
import styles from './VoteButton.module.css';

interface VoteButtonProps {
  slug: string;
  actId: string;
}

/**
 * "Ich bin dabei"-Button. Liest Identity aus useAuth, votet via useVotes
 * (mit optimistischem Update + Rollback). Identifikation primär per
 * Session-Token, fällt sonst auf Anzeige-Namen zurück.
 */
export function VoteButton({ slug, actId }: VoteButtonProps) {
  const { identity } = useAuth(slug);
  const { votes, voteMutation } = useVotes(slug);

  const voters = votes[actId] ?? [];
  const me = { token: identity?.token, name: identity?.name ?? identity?.username ?? '' };
  const voted = hasVoted(votes, actId, me);
  const count = voters.length;

  const disabled = voteMutation.isPending || !me.name;

  function onClick() {
    if (!me.name) return;
    voteMutation.mutate({
      actId,
      vote: !voted,
      name: me.name,
      ownVoterKey: voterKey(me),
    });
  }

  return (
    <button
      type="button"
      className={`${styles.button} ${voted ? styles.on : ''}`}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={voted}
    >
      {voted ? '✓ Ich bin dabei' : '👥 Ich bin dabei'}
      {count > 0 ? <span className={styles.count}>{count}</span> : null}
    </button>
  );
}
